<template>
  <section>
    <nav class="level">
      <div class="level-left">
        <h1>會員管理</h1>
      </div>
    </nav>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <b-field>
            <b-input
              v-model="searchName"
              :placeholder="$t('attributes.search') + $t('attributes.name')"
              type="search"
              icon="magnify"
              @input="onInput"
            ></b-input>
          </b-field>
        </div>
        <div class="level-item">
          <b-field>
            <b-input
              v-model="searchIdNo"
              :placeholder="
                $t('attributes.search') + $t('attributes.identity_number')
              "
              type="search"
              icon="magnify"
              @input="onInput"
            ></b-input>
          </b-field>
        </div>
        <div class="level-item">
          <b-field>
            <b-input
              v-model="searchPhoneNumber"
              :placeholder="
                $t('attributes.search') + $t('attributes.phone_number')
              "
              type="search"
              icon="magnify"
              @input="onInput"
            ></b-input>
          </b-field>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-button :loading="loadingItems" type="is-info" @click="onInput">
            <b-icon icon="refresh"></b-icon>
          </b-button>
        </div>
      </div>
    </nav>
    <b-table
      ref="table"
      :data="items"
      :loading="loadingItems"
      :mobile-cards="false"
      hoverable
      narrowed
      bordered
      paginated
      pagination-position="both"
      backend-pagination
      backend-sorting
      :total="total"
      :per-page="perPage"
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      @page-change="onPageChange"
      @sort="onSort"
    >
      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        centered
        sortable
        cell-class="nowrap"
        v-slot="props"
      >
        {{ props.row.display_name }}
      </b-table-column>
      <b-table-column
        field="identity"
        :label="
          $t('attributes.identity_number') +
            ' / ' +
            $t('attributes.passport_number')
        "
        centered
        sortable
        header-class="nowrap"
        cell-class="nowrap"
        v-slot="props"
      >
        {{ props.row.identity }}
      </b-table-column>
      <b-table-column
        field="nationality"
        :label="$t('attributes.nationality')"
        :width="100"
        centered
        sortable
        cell-class="nowrap"
        v-slot="props"
      >
        {{ props.row.nationality_type_name }}
      </b-table-column>
      <b-table-column
        field="gender"
        :label="$t('attributes.gender')"
        centered
        sortable
        header-class="nowrap"
        v-slot="props"
      >
        {{ props.row.gender === 'M' ? '男' : '女' }}
      </b-table-column>
      <b-table-column
        field="date_of_birth"
        :label="$t('attributes.date_of_birth')"
        centered
        sortable
        width="120"
        cell-class="nowrap"
        v-slot="props"
      >
        {{ props.row.date_of_birth.split('T')[0] }}
      </b-table-column>
      <b-table-column
        field="phone_number"
        :label="$t('attributes.phone_number')"
        centered
        cell-class="nowrap"
        v-slot="props"
      >
        {{ props.row.phone_number }}
      </b-table-column>
      <b-table-column
        field="tel"
        :label="$t('attributes.tel')"
        centered
        cell-class="nowrap"
        v-slot="props"
      >
        {{ props.row.tel }}
      </b-table-column>
      <b-table-column
        field="email"
        :label="$t('attributes.email')"
        centered
        header-class="nowrap"
        cell-class="nowrap"
        v-slot="props"
      >
        {{ props.row.email }}
      </b-table-column>
      <b-table-column
        field="email_confirmed"
        :label="$t('attributes.email') + $t('attributes.confirmed')"
        centered
        sortable
        header-class="nowrap"
        v-slot="props"
      >
        <b-tag
          :type="props.row.email_confirmed ? 'is-success' : 'is-danger'"
          size="is-medium"
        >
          {{ confirmedStatus(props.row.email_confirmed) }}
        </b-tag>
      </b-table-column>
      <b-table-column
        field="address"
        :label="$t('attributes.address')"
        centered
        v-slot="props"
      >
        {{ props.row.zip }}
        {{ props.row.address }}
      </b-table-column>
    </b-table>
  </section>
</template>

<script>
import { USER_API } from '@/utils/apis'
import { debounce } from 'lodash'

export default {
  name: 'MemberList',
  data() {
    return {
      loadingItems: false,
      total: 0,
      items: [],
      selectedItem: null,

      searchName: '',
      searchIdNo: '',
      searchPhoneNumber: '',

      sortField: 'CreatedAt',
      sortOrder: 'desc',
      defaultSortOrder: 'asc',
      page: 1,
      perPage: 10
    }
  },
  mounted() {
    this.loadItems()
  },
  methods: {
    async loadItems() {
      try {
        const params = {
          name: this.searchName,
          id: this.searchIdNo,
          phone_number: this.searchPhoneNumber,
          sort_by: this.sortField,
          by_descending: this.sortOrder !== 'asc',
          page_size: this.perPage,
          page_number: this.page
        }
        this.loadingItems = true
        const res = await this.axios.get(USER_API, { params })
        const data = res.data.data

        this.items = data.items
        this.total = data.item_count
      } catch (e) {
        this.items = []
        this.total = 0
      } finally {
        this.loadingItems = false
      }
    },
    onInput: debounce(function() {
      this.loadItems()
    }, 500),
    onPageChange(page) {
      this.page = page

      this.loadItems()
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order

      this.loadItems()
    }
  }
}
</script>
